export const siteInfo = {
  name: "黑瓜爆料",
  nameEn: "HEIGUA TRACKER",
  slogan: "瓜田追踪 · 不漏掉每一步反转",
  tagline: "事件追踪型娱乐资讯站",
  description:
    "黑瓜爆料持续追踪每一条娱乐线索，跟进当事人回应、反转节点与最新进展，用一条时间线帮你看懂事件从始至终。",
  email: "editor@heigua-insider.example",
  cooperation: "track@heigua-insider.example",
  since: "2021",
  stats: [
    { label: "追踪事件", value: "1,286", suffix: "条" },
    { label: "反转节点", value: "3,470", suffix: "次" },
    { label: "当事人回应", value: "642", suffix: "份" },
    { label: "持续跟进", value: "24", suffix: "小时" },
  ],
  principles: [
    {
      icon: "ri-route-line",
      title: "一条线索一条时间线",
      desc: "任何爆料都从首次流出开始建档，后续的每一次回应、澄清与反转都会追加进同一条时间线，不做孤立碎片。",
    },
    {
      icon: "ri-scales-3-line",
      title: "多方信源交叉核对",
      desc: "我们至少要求两个相互独立的信源指向同一事实，才会把它写进已核实部分，其余一律标注为待确认。",
    },
    {
      icon: "ri-chat-check-line",
      title: "给当事人留出回应位",
      desc: "每条追踪都保留当事人回应栏位。暂时没有回应不是结论，我们会在时间线里如实标注「暂未回应」。",
    },
    {
      icon: "ri-eraser-line",
      title: "有错就改，改在明处",
      desc: "若后续信息证伪了此前的判断，我们不删帖了事，而是在时间线里保留原始节点并追加更正说明。",
    },
  ],
};

export const navLinks = [
  { label: "首页", href: "/", anchor: false },
  { label: "全部追踪", href: "/news", anchor: false },
  { label: "反转现场", href: "/news?category=%E5%8F%8D%E8%BD%AC%E7%8E%B0%E5%9C%BA", anchor: false },
  { label: "关于我们", href: "/about", anchor: false },
];